var msMS = {
  locale: 'ms_MY',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'],
    monthList: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'],
    shortDayList: ['Aha', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
    dayList: ['Aha', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
    shortestDayList: ['Ah', 'Is', 'Se', 'Ra', 'Kh', 'Ju', 'Sa']
  },
  'dynamic-date': {
    day: 'Hari',
    week: 'Minggu',
    month: 'Bulan',
    quarter: 'Suku',
    year: 'Tahun',
    before: 'Sebelum ${value}${unit}'
  },
  'auto-complete.empty': 'Tiada data',
  'select.selected-count': '${count} item dipilih',
  'date-time-picker.date': 'Pilih tarikh',
  'image-view.zoom-out': 'Zum keluar',
  'input.placeholder': 'Sila masukkan',
  'empty.text': 'Tiada data',
  'date-picker.cancel': 'Batal',
  'date-picker.end': 'Masa tamat',
  'cascader.empty': 'Tiada data',
  'upload.drop': 'Seret fail ke sini atau',
  'color.custom': 'Sesuaikan warna',
  'cascader.titles': ['Tahap 1', 'Tahap 2', 'Tahap 3', 'Tahap 4', 'Tahap 5', 'Tahap 6', 'Tahap 7', 'Tahap 8'],
  'date-comparison.error-target': 'Pilih masa tamat untuk perbandingan',
  'transfer.empty': 'Tiada data',
  'select.search.placeholder': 'Sila masukkan',
  'upload.click': 'Klik untuk memuat naik',
  'date-time-picker.placeholder': 'Sila masukkan',
  'pager.jump': 'Hala semula',
  'tree-select.placeholder': 'Sila masukkan',
  'dynamic-date.interval': 'Selang',
  'modal.cancel': 'Batal',
  'image-view.rotate': 'Putar',
  'tabs.more': 'Lagi',
  'popover.ok': 'Sahkan',
  'transfer.placeholder': 'Sila masukkan',
  'date.month': 'Bulan',
  'select.selected': 'Dipilih',
  'popover.cancel': 'Batal',
  'image-view.prev': 'Sebelumnya',
  'table.emptyText': 'Tiada data',
  'date-time-picker.ok': 'Sahkan',
  'table.filter.confirm': 'Sahkan',
  'tree-select.empty': 'Tiada data',
  'dynamic-date.fixed-date': 'Tarikh tetap',
  'date-comparison.compare': 'Bandingkan',
  'auto-complete.placeholder': 'Sila masukkan',
  'time-picker.placeholder': 'Pilih masa',
  'date.month-first': false,
  'select.clear': 'Kosong',
  'date.year': 'Tahun ${year}',
  'date-comparison.yoy': 'Tempoh masa ini tahun lepas',
  'image-view.zoom-to-origin': 'Asal',
  'schedule.title': 'Tarikh/Masa',
  'schedule.clear': 'Kosong',
  'date-time-picker.end': 'Pilih tarikh dan masa tamat',
  'dynamic-date.customize': 'Sesuaikan',
  'date-picker.apply': 'Gunakan',
  'schedule.selected': 'Masa yang dipilih',
  'dynamic-date.dynamic-date': 'Tarikh dinamik',
  'select.placeholder': 'Sila pilih',
  'schedule.separator': ',',
  'cascader.search': 'Sila masukkan',
  'date-picker.invalid-range': 'Julat masa yang dipilih melebihi julat yang boleh dipilih. Sila pilih julat yang sah.',
  'dynamic-date.date-preview': 'Pratonton tarikh',
  'select.empty': 'Tiada data',
  'image-view.next': '  Seterusnya',
  'date-time-picker.now': 'Sekarang',
  'date-time-picker.time': 'Pilih masa',
  'tree.empty': 'Tiada data',
  'pager.total': '${total} rekod secara keseluruhan',
  'image-view.zoom-in': 'Zum masuk',
  'date-picker.placeholder': 'Pilih tarikh',
  'textarea.placeholder': 'Sila masukkan',
  'date.week': 'Minggu',
  'pager.size': '${count} rekod/halaman',
  'modal.ok': 'Sahkan',
  'date-picker.start': 'Masa mula',
  'table.filter.reset': 'Tetapkan semula',
  'image-view.zoom-to-fit': 'Muatkan',
  'pager.page.placeholder': 'Sila masukkan',
  'select.select-all': 'Pilih semua',
  'list-viewer.empty': 'Tiada data',
  'date-comparison.compare-text': 'VS',
  'transfer.source': 'Senarai sumber',
  'date-time-picker.start': 'Pilih tarikh dan masa mula',
  'date-time-picker-panel.start': 'Tarikh mula',
  'date-time-picker-panel.end': 'Tarikh tamat',
  'date-comparison.error-source': 'Pilih masa mula untuk perbandingan',
  'upload.error.overflow-count': 'Melebihi bilangan maksimum fail',
  'date-comparison.placeholder': 'Masa mula - Masa tamat',
  'time-range-picker.placeholder': 'Masa mula - Masa tamat',
  'date-comparison.mom': 'Berbanding dengan tempoh masa sebelumnya',
  'transfer.target': 'Senarai sasaran',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default msMS;